
import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import BookingForm from './components/BookingForm';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ServiceAreas from './components/ServiceAreas';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Services />
      <HowItWorks />
      <Pricing />
      <BookingForm />
      <Testimonials />
      <FAQ />
      <ServiceAreas />
      <Footer />
    </div>
  );
}
